<template>
  <div class="holder">

{{this.$route.params.title}}
<div v-for="item in catarray" :key="item">
   <div v-if="item.slug === this.$route.params.title">
    <div class="display-6">{{item.title}}</div>
   <div class="content">{{item.content}}</div>
</div>
</div>
  <div  v-for="title in catJson" :key="title">
    <div v-if="title.slug === this.$route.params.title">
   <div class="display-6">{{title.title}}</div>
   <div class="content">{{title.content}}</div>
</div>

  </div>
  <section v-if="errored">
    <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
  </section>
</div>
</template>

<script>
import axios from 'axios'
import { catPromise } from '@/stores/store.js';
export default {
  data () {
    return {
      info: null,
      loading: true,
      errored: false,
       catJson: '',
        catarray: '',
    }
  },

  mounted () {
    catPromise.then(data => {
  console.log(data.acf.content_repeater);
   this.catarray = data.acf.content_repeater
});
  console.log('description-mounted');
    axios
      .get('https://wanada.org.au/wp-json/acf/v3/options/options')
      .then(response => {
         console.log(response.data)
        this.catJson = response.data.acf.content_repeater

      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => this.loading = false,
      )
  }
}
</script>

<style>

</style>
